var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalBillboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21V15H15V21",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21V15H15V21",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72593 13H18.2804C18.6781 13 19 13.4939 19 14.1041V14.2494C19 15.77 18.1983 17 17.2073 17H8.79274C7.80168 17 7 15.77 7 14.2494V14.1041C7 13.4939 7.32194 13 7.71962 13H7.72593Z",
    fill: "white",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0977 3.28906H1.91242C1.49696 3.28906 1.16016 3.62586 1.16016 4.04133V12.9828C1.16016 13.3982 1.49696 13.735 1.91242 13.735H24.0977C24.5132 13.735 24.85 13.3982 24.85 12.9828V4.04133C24.85 3.62586 24.5132 3.28906 24.0977 3.28906Z",
    fill: "white",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 3.29063V1.13281",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91187 0H1.59568C1.35515 0 1.16016 0.194991 1.16016 0.435524V1.01622C1.16016 1.25676 1.35515 1.45175 1.59568 1.45175H3.91187C4.15241 1.45175 4.3474 1.25676 4.3474 1.01622V0.435524C4.3474 0.194991 4.15241 0 3.91187 0Z",
    fill: "#5B5E5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9297 3.29063V1.13281",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0916 0H20.7754C20.5348 0 20.3398 0.194991 20.3398 0.435524V1.01622C20.3398 1.25676 20.5348 1.45175 20.7754 1.45175H23.0916C23.3321 1.45175 23.5271 1.25676 23.5271 1.01622V0.435524C23.5271 0.194991 23.3321 0 23.0916 0Z",
    fill: "#5B5E5D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0039 3.29063V1.13281",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.158 0H11.8418C11.6012 0 11.4062 0.194991 11.4062 0.435524V1.01622C11.4062 1.25676 11.6012 1.45175 11.8418 1.45175H14.158C14.3985 1.45175 14.5935 1.25676 14.5935 1.01622V0.435524C14.5935 0.194991 14.3985 0 14.158 0Z",
    fill: "#5B5E5D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 3.29063V1.13281",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02906 0H6.71287C6.47233 0 6.27734 0.194991 6.27734 0.435524V1.01622C6.27734 1.25676 6.47233 1.45175 6.71287 1.45175H9.02906C9.2696 1.45175 9.46459 1.25676 9.46459 1.01622V0.435524C9.46459 0.194991 9.2696 0 9.02906 0Z",
    fill: "#5B5E5D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4648 3.29063V1.13281",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6267 0H16.3105C16.07 0 15.875 0.194991 15.875 0.435524V1.01622C15.875 1.25676 16.07 1.45175 16.3105 1.45175H18.6267C18.8673 1.45175 19.0622 1.25676 19.0622 1.01622V0.435524C19.0622 0.194991 18.8673 0 18.6267 0Z",
    fill: "#5B5E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalBillboard);
export default __webpack_public_path__ + "static/media/digital-billboard.c5a5f0b49f27dfa7a5d72665930948b0.svg";
export { ForwardRef as ReactComponent };